import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import {
    AssignedProfilesObsService,
} from '@client/app/modules/page-performance/services/assigned-profiles-obs/assigned-profiles-obs.service';
import {
    PagePerformanceProfileObsService,
} from '@client/app/modules/page-performance/services/profile-obs/profile-obs.service';

@Injectable({
    providedIn: 'root',
})

export class PagePerformanceRunService {
    constructor (
        private monEventService: MonEventService,
        private activeFeatureService: ActiveFeatureService,
        private pagePerformanceProfileObsService: PagePerformanceProfileObsService,
        private assignedProfilesObsService: AssignedProfilesObsService,
    ) {}
    initializeApp () {
        this.monEventService.addListener('finishCustomer', (url, title, ref, type, params) => {
            if (this.activeFeatureService.isFeatureActive('admin_page_performance')) {
                this.pagePerformanceProfileObsService.startLiveReload();
                this.assignedProfilesObsService.startLiveReload();
            }
        });

        this.monEventService.addListener('exitCustomer', (url, type, ref) => {
            this.pagePerformanceProfileObsService.disposeProfiles();
            this.assignedProfilesObsService.disposeAssignedProfiles();
        });

        this.monEventService.addListener('logout', (url, title, ref, type, params) => {
            this.pagePerformanceProfileObsService.disposeProfiles();
            this.assignedProfilesObsService.disposeAssignedProfiles();
        });
    }
}
